import React, { Component } from 'react'
import shortid from "shortid";
import MyComponent from '../components/MyComponent';

export class PageSlotContainer extends Component {

    render() {
        var state = this.props.state;
       var contentId = state.contentId
        var pagewidth = state.attributes.width
        const stylesObj = {
            width: pagewidth
        };
        return (

            <div className={`containerWarp `} data-cont-id={contentId ? contentId : ""} data-zone="ContentFolderZone" data-zone-id="Content Rule Zone" >
                <div className="primary-zone" data-zone="ContentFolderZone" >
                    <div className={"row m-0 " + state.attributes.class ? state.attributes.class : ""} data-page-id={contentId ? contentId : ""} id={state.attributes.id} data-id="zone" data-zone="ContentFolderZone" >
                        <div className="content row  container-fluid justify-content-around gx-0 p-0 mobile-width-style" style={stylesObj} data-page-id={contentId ? contentId : ""} data-id="zone" data-zone="ContentFolderZone">
                            {/* <NavbarHeader/>                    */}
                            {state.contents && state.contents.ContentFolderZone && state.contents.ContentFolderZone.map(content => {
                                let contentFolderZoneType = content['@type'];
                                return (
                                    <MyComponent type={contentFolderZoneType} key={shortid.generate()} containerObject={content} contentId={contentId} dataZone="ContentFolderZone" templateName={contentFolderZoneType} />
                                )
                            }
                            )}
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}
export default (PageSlotContainer);
